// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"255":"0821143f","664":"e9e3b6aa"}[chunkId] + ".chunk.js";
};